export default "__VITE_ASSET__D4b55H2C__"